import {endpointsMap, IPutAbandonedCartOptions} from './ICustomShopperAbandonedCart';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperAbandonedCart
 */
class CustomShopperAbandonedCart extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Create update or delete an abandoned cart
	 * @param {IPutAbandonedCartOptions} fetchOptions - options to pass to API Call
	 * @returns {void}
	 */
	public upsertAbandonedCart(fetchOptions: IPutAbandonedCartOptions): Promise<void> {
		return this.callCustomEndpoint(fetchOptions || {}, endpointsMap.PUT_ABANDONEDCART);
	}
}

export default CustomShopperAbandonedCart;
